import React, { useState } from "react";
import axios from "axios";
import { ArrowRight, CheckCircle2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HeroEmailCapture = ({ source = "hero_cta", id }) => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle"); // idle | loading | success | error
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setError("Please enter a valid email.");
            return;
        }
        setStatus("loading");
        try {
            await axios.post(`${API}/leads/email`, { email, source });
            if (typeof window.fbq === "function") {
                window.fbq("track", "Lead");
            }
            setStatus("success");
            setEmail("");
        } catch (err) {
            console.error(err);
            setStatus("error");
            setError("Something went wrong. Please try again.");
        }
    };

    if (status === "success") {
        return (
            <div
                data-testid="hero-email-success"
                id={id}
                className="bg-accent text-accent-foreground p-6 flex items-start gap-4 max-w-xl"
            >
                <CheckCircle2 className="w-6 h-6 shrink-0 mt-1" />
                <div>
                    <div className="font-display font-black uppercase tracking-tight text-lg">
                        You're on the list.
                    </div>
                    <div className="text-sm opacity-90 mt-1">
                        Our preconstruction team will be in touch within one business day.
                    </div>
                </div>
            </div>
        );
    }

    return (
        <form
            id={id}
            data-testid="hero-email-form"
            onSubmit={handleSubmit}
            noValidate
            className="w-full max-w-xl"
        >
            <div className="flex flex-col sm:flex-row gap-0 sm:gap-0 border border-foreground/20 bg-background/95 backdrop-blur-sm p-2">
                <input
                    type="email"
                    inputMode="email"
                    placeholder="your@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="hero-email-input"
                    className="flex-1 bg-transparent px-4 py-3 text-foreground placeholder:text-muted-foreground focus:outline-none font-mono text-sm"
                    disabled={status === "loading"}
                />
                <button
                    type="submit"
                    data-testid="hero-email-submit"
                    disabled={status === "loading"}
                    className="group inline-flex items-center justify-center gap-2 bg-accent text-accent-foreground px-6 py-3 text-sm font-bold uppercase tracking-wider hover:bg-foreground transition-colors disabled:opacity-60"
                >
                    {status === "loading" ? (
                        <>
                            <Loader2 className="w-4 h-4 animate-spin" />
                            Sending
                        </>
                    ) : (
                        <>
                            Click Here
                            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                        </>
                    )}
                </button>
            </div>
            <div className="mt-3 flex items-center justify-end text-xs font-mono uppercase tracking-wider">
                {error && (
                    <span className="text-destructive normal-case" data-testid="hero-email-error">
                        {error}
                    </span>
                )}
            </div>
        </form>
    );
};

export default HeroEmailCapture;
